import { render, staticRenderFns } from "./CellNumber.vue?vue&type=template&id=1681835b"
import script from "./CellNumber.vue?vue&type=script&lang=js"
export * from "./CellNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports